import { Control, FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import GaiaSliderElement from "~/modules/app/components/GaiaSliderElement";

import { PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY } from "../../../constants";

type Props<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    disabled?: boolean;
};

export default function PrecipitationSlider<T extends FieldValues>({ control, name, disabled }: Props<T>) {
    const { t } = useTranslation("protocol");

    return (
        <GaiaSliderElement
            control={control}
            name={name}
            label={t("protocolVisitsWeatherEditor.labelMaxPrecipitation")}
            min={0}
            max={6}
            step={1}
            disabled={disabled}
            valueLabelFormat={value =>
                t(`protocolVisitsWeatherEditor.precipitation.${PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY[value]}`)
            }
            marks={PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY.map((level, index) => ({
                value: index,
                label: t(`protocolVisitsWeatherEditor.precipitation.${level}`),
            }))}
        />
    );
}
